module.exports = __webpack_public_path__ + "media/images/achievement_category/board_best_answer_count-463d77535f8e54768604de02959715bf.png";